const popupAddressCopyOption = document.getElementById(
  "popupAddressCopyOption",
);
const popupAddressCopyOptionMessage = document.getElementById(
  "popupAddressCopyOptionMessage",
);

popupAddressCopyOption.addEventListener("click", () => {
  // Copy the current page URL
  navigator.clipboard
    .writeText("13 bis Rue Saint-Lazare, 49100 Angers")
    .then(() => {
      // Show popupAddressCopyOptionMessage
      popupAddressCopyOptionMessage.classList.add("show");

      // Hide after 2 seconds
      setTimeout(() => {
        popupAddressCopyOptionMessage.classList.remove("show");
      }, 2000);
    })
    .catch((err) => console.error("Failed to copy: ", err));
});

const popupAddressInvoke = document.getElementById("popupAddressInvoke");
const popupAddressInvokeImage = document.getElementById(
  "popupAddressInvokeImage",
);
const popupAddressOverlay = document.querySelector(".popupAddressOverlay");
//const popupAddressOverlay = document.body;
const body = document.body;
const popupAdressCloseButton = document.querySelector(".popup-address-close");
let popupAddressToggle = false; // false = closed, true = open

const popupAddressInside = document.querySelector(".popup-address"); // note querySelector, NOT querySelectorAll
// Open popup
popupAddressInvoke.addEventListener("click", (e) => {
  e.stopPropagation(); // ✅ stop click from bubbling to document
  if (!popupAddressToggle) {
    body.style.overflow = "hidden";
    popupAddressOverlay.style.display = "flex";
    popupAddressToggle = true;
  }
});
popupAddressInvokeImage.addEventListener("click", (e) => {
  e.stopPropagation(); // ✅ stop click from bubbling to document
  if (!popupAddressToggle) {
    body.style.overflow = "hidden";
    popupAddressOverlay.style.display = "flex";
    popupAddressToggle = true;
  }
});

// Click outside popup to close
popupAddressOverlay.addEventListener("click", (e) => {
  if (e.target === popupAddressOverlay) {
    body.style.overflow = "";
    popupAddressOverlay.style.display = "none";
    popupAddressToggle = false; // reset immediately
  }
});

// Prevent clicks inside popup from closing it
popupAddressInside.addEventListener("click", (e) => e.stopPropagation());

popupAdressCloseButton.addEventListener("click", (e) => {
  if (e.target === popupAdressCloseButton) {
    popupAddressOverlay.style.display = "none";
    body.style.overflow = "";
    popupAddressToggle = false;
  }
});
